import Snackbar from "awesome-snackbar";

import { useTheme } from "./useTheme";

export const useSuccessBanner = () => {
  const { theme } = useTheme();

  const showSuccessBanner = (message: string) => {
    new Snackbar(`<p class="errorBanner">${message}</p>`, {
      position: "bottom-center",
      style: {
        container: [["background-color", theme.success.background]],
      },
    });
  };

  return { showSuccessBanner };
};
